import { z } from 'zod';
import { ISOSubdivisionVO } from "../../../../common/validators/value-objects/iso.js";
export const PersonOfficialAddressDTOSchema = z.object({
    postcode: z.string().nullable(),
    thoroughfare: z.string().nullable(),
    premiseNumber: z.string().nullable(),
    subPremise: z.string().nullable(),
    premise: z.string().nullable(),
    locality: z.string().nullable(),
    subdivisionId: ISOSubdivisionVO.nullable(),
});
export const PersonOfficialDataDTOSchema = z.object({
    birthDate: z.string().nullable(),
    motherName: z.string().nullable(),
    address: PersonOfficialAddressDTOSchema.nullable(),
    // Income in cents (integer). Backend convention: money is always cents on
    // the logic side; UI converts to reais at display boundaries via centsToReais.
    income: z.number().int().nullable(),
});
// Action-layer input
export const FindPersonOfficialDataActionInputDTOSchema = z.object({
    companyId: z.uuid(),
    personId: z.uuid(),
});
// API layer DTOs
export const FindPersonOfficialDataRequestDTOSchema = z.object({
    params: z.object({
        companyId: z.uuid(),
        personId: z.uuid(),
    }),
});
export const ExposedPersonOfficialAddressDTOSchema = z.object({
    postcode: z.string().nullable(),
    thoroughfare: z.string().nullable(),
    premiseNumber: z.string().nullable(),
    subPremise: z.string().nullable(),
    premise: z.string().nullable(),
    locality: z.string().nullable(),
    subdivisionId: ISOSubdivisionVO.nullable(),
});
export const ExposedPersonOfficialDataDTOSchema = z.object({
    birthDate: z.string().nullable(),
    motherName: z.string().nullable(),
    address: ExposedPersonOfficialAddressDTOSchema.nullable(),
    income: z.number().nullable(),
});
//# sourceMappingURL=person-official-data.dto.js.map